import { Box, IconButton } from "@mui/material";
import AgricultureOutlined from "@mui/icons-material/AgricultureOutlined";
import { formatDate } from "../../utils/formatDate";
import { getHarvestTypeByValue } from "../../constants/enums";

const forcesColumns = (handleSeeApplications, colors) => [
  {
    field: "forced_week",
    headerName: "Sem Forza",
    headerAlign: "left",
    align: "left",
    flex:  0.6,
  },
  {
    field: "lote_name",
    headerName: "Lote",
    headerAlign: "left",
    align: "left",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "number",
    headerName: "Bloques",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "forced_date",
    headerName: "Fecha Forza",
    headerAlign: "left",
    align: "left",
    flex:  0.7,
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "plants",
    headerName: "Plantas",
    headerAlign: "left",
    align: "left",
    flex: 0.5,
  },
  {
    field: "harvest_date",
    headerName: "Fecha Cosecha",
    headerAlign: "left",
    align: "left",
    flex:  0.7,
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "harvest_week",
    headerName: "Sem Cosecha",
    headerAlign: "left",
    align: "left",
    flex:  0.6,
  },
  {
    field: "harvest_tag",
    headerName: "Cosecha",
    headerAlign: "center",
    align: "center",
    flex: 0.7,
    renderCell: (params) => {
      const typeInfo = getHarvestTypeByValue(params.value);
  
      return (
        <Box
          sx={{
            color: typeInfo.color,
            fontWeight: "bold",
            backgroundColor: `${typeInfo.color}30`, // Transparent background
            border: ` ${typeInfo.color}`, // Corner borders
            borderRadius: "8px", // Rounded corners
            padding: "8px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50%",
            height: "50%",
            textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
            overflow: "hidden", // Prevent shadow from going outside the box
          }}
        >
          {typeInfo.label}
        </Box>
      );
    },
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.5,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleSeeApplications(params.row)} sx={{ color: colors.grey[100] }}>
          <AgricultureOutlined />
        </IconButton>
      </Box>
    ),
  },
];

export { forcesColumns };
